<template>
  <div>
    <tapout-component
      class="text-container"
      :style="{
        transform: `translate(${x + dx}px, ${y + dy}px)`,
        width: `${setTextWidth + 10}px`
      }"
      @tapout="onBlur"
      id="textContainer"
      @onClick="$emit('onClick')"
    >
      <div
        class="text-box"
        :class="[
          !operation ? 'grab' : '',
          operation === 'move' ? 'grabbing' : '',
          ['edit', 'tool'].includes(operation) ? 'disabled-border' : '',
          edit === true ? 'dotted-red-border' : ''
        ]"
        @mousedown="handlePanStart"
        @touchstart="handlePanStart"
      />
      <div
        ref="editable"
        :contenteditable="textEditable"
        spellcheck="false"
        class="editable-text"
        :style="{
          color: 'black',
          fontSize: `${this.size}px`,
          fontFamily: `${this.fontFamily_}, serif`,
          lineHeight: `${this.lineHeight_}`,
          textAlign: `${this.textAlign}`,
          fontWeight: `${this.fontWeight}`,
          background: `${textBackground}`,
          fontStyle: `${this.fontStyle}`
        }"
        @focus="onFocus"
        @keydown="onKeydown"
        @paste.prevent="onPaste"
      />
    </tapout-component>
  </div>
</template>

<script>
import itemEventsMixin from "./ItemEventsMixin.vue";
import ToolbarComponent from "./Toolbar";
import TapoutComponent from "./Tapout";
import {Fonts} from "../pdf-lib-utils/prepareAssets";
import {timeout} from "../pdf-lib-utils/helper";
import Konva from "konva";
import constants from "../../../../constants";

export default {
  name: "TextComponent",
  components: {
    ToolbarComponent,
    TapoutComponent,
  },
  mixins: [itemEventsMixin],
  props: ["size", "text", "lineHeight", "x", "y", "fontFamily", "pageScale", "textAlign", "fontWeight", "fontStyle", "transparent", "textEditable"],
  data() {
    return {
      Families: Object.keys(Fonts),
      startX: null,
      startY: null,
      // editable: null,
      dx: 0,
      dy: 0,
      operation: "",
      size_: this.size,
      lineHeight_: this.lineHeight,
      fontFamily_: this.fontFamily,
      edit: false,
      textBackground: this.transparent
    };
  },
  computed: {
    setTextWidth() {
      if (this.textEditable === true) {
        return 250;
      } else {
        const textKonva = new Konva.Text({
          x: 0,
          y: 0,
          text: this.text,
          fontSize: this.size,
          fontFamily: 'Times New Roman',
          fill: 'black',
          align: this.textAlign,
          fontWeight: this.fontWeight,
          fontStyle: this.fontStyle
        });

        return textKonva.textWidth;
      }
    },
  },
  watch: {
  },
  mounted() {
    this.render();
  },
  created() {},
  methods: {
    getTextWidth(text) {
      const textKonva = new Konva.Text({
        x: 0,
        y: 0,
        text: text,
        fontSize: this.size,
        fontFamily: 'Times New Roman',
        fill: 'black',
        align: this.textAlign,
        fontWeight: this.fontWeight,
        fontStyle: this.fontStyle
      });

      return textKonva.textWidth;
    },

    addLineBreaks(text, width) {
      let words = text.split(' ');
      let newtext = words[0];
      for (let i = 1; i < words.length; i++) {
        let testText = newtext + ' ' + words[i];
        if (this.getTextWidth(testText) > width) {
          newtext = newtext + '\n' + words[i];
        } else {
          newtext = testText;
        }
      }
      return newtext;
    },

    handlePanMove(event) {
      let coordinate;
      if (event.type === "mousemove") {
        coordinate = this.handleMousemove(event);
      }
      if (event.type === "touchmove") {
        coordinate = this.handleTouchmove(event);
      }
      if (!coordinate) return console.log("ERROR");

      this.dx = (coordinate.detail.x - this.startX) / this.pageScale;
      this.dy = (coordinate.detail.y - this.startY) / this.pageScale;
      this.edit = true;
    },

    handlePanEnd(event) {
      this.edit = true;
      let coordinate;
      if (event.type === "mouseup") {
        coordinate = this.handleMouseup(event);
      }
      if (event.type === "touchend") {
        coordinate = this.handleTouchend(event);
      }
      if (!coordinate) return console.log("ERROR");

      if (this.dx === 0 && this.dy === 0) {
        return this.$refs.editable.focus();
      }
      this.$emit("onUpdate", {
        x: this.x + this.dx,
        y: this.y + this.dy,
        fontWeight: this.fontWeight,
        fontStyle: this.fontStyle
      });

      this.dx = 0;
      this.dy = 0;
      this.operation = "";
    },
    handlePanStart(event) {
      let coordinate;
      if (event.type === "mousedown") {
        coordinate = this.handleMousedown(event);
      }
      if (event.type === "touchstart") {
        coordinate = this.handleTouchStart(event);
      }
      if (!coordinate) return console.log("ERROR");

      this.startX = coordinate.detail.x;
      this.startY = coordinate.detail.y;
      this.operation = "move";
      this.edit = true;
    },
    onFocus() {
      this.operation = "edit";
      this.edit = true;
    },
    async onBlur() {
      this.edit = false;
      this.$refs.editable.blur();
      this.sanitize();
      this.$emit("onUpdate", {
        text: this.extractLines(),
        width: this.$refs.editable.clientWidth,
        fontWeight: this.fontWeight,
        fontStyle: this.fontStyle
      });
      this.operation = "";
    },
    async onPaste(e) {
      // get text only
      const pastedText = e.clipboardData.getData("text");
      this.text = pastedText;
      document.execCommand("insertHTML", false, pastedText);
      // await tick() is not enough
      await timeout();
      this.sanitize();
      this.edit = true;
    },
    onKeydown(e) {
      this.edit = true;
      const childNodes = Array.from(this.$refs.editable.childNodes);
      if (e.keyCode === 13) {
        // prevent default adding div behavior
        e.preventDefault();
        const selection = window.getSelection();
        const focusNode = selection.focusNode;
        const focusOffset = selection.focusOffset;
        // the caret is at an empty line
        if (focusNode === this.$refs.editable) {
          this.$refs.editable.insertBefore(
              document.createElement("br"),
              childNodes[focusOffset],
          );
        } else if (focusNode instanceof HTMLBRElement) {
          this.$refs.editable.insertBefore(
              document.createElement("br"),
              focusNode,
          );
        }
        // the caret is at a text line but not end
        else if (focusNode.textContent.length !== focusOffset) {
          document.execCommand("insertHTML", false, "<br>");
          // the carat is at the end of a text line
        } else {
          let br = focusNode.nextSibling;
          if (br) {
            this.$refs.editable.insertBefore(
                document.createElement("br"),
                br,
            );
          } else {
            br = this.$refs.editable.appendChild(
                document.createElement("br"),
            );
            br = this.$refs.editable.appendChild(
                document.createElement("br"),
            );
          }
          // set selection to new line
          selection.collapse(br, 0);
        }
      }
    },
    sanitize() {
      let weirdNode;
      while (
          (weirdNode = Array.from(this.$refs.editable.childNodes).find(
              (node) => !["#text", "BR"].includes(node.nodeName),
          ))
          ) {
        this.$refs.editable.removeChild(weirdNode);
      }
    },
    render() {
      if (this.text === constants.TEXT_VALUE.DEFAULT_TEXT) {
        this.$refs.editable.innerHTML = '';
      } else {
        this.$refs.editable.innerHTML = this.text;
      }
      this.$refs.editable.focus();
      this.edit = true;
    },
    extractLines() {
      const nodes = this.$refs.editable.childNodes;
      const lines = [];
      let lineText = "";
      for (let index = 0; index < nodes.length; index++) {
        const node = nodes[index];
        if (node.nodeName === "BR") {
          lines.push(lineText);
          lineText = "";
        } else {
          lineText += node.textContent;
        }
      }

      const width = this.getTextWidth(lineText);
      let container = this.$el.querySelector('#textContainer');
      let containerWidth = container.offsetWidth;
      if (width > containerWidth) {
        lineText = this.addLineBreaks(lineText, containerWidth);
      }
      lines.push(lineText);
      return lines;
    },
  },
};
</script>
<style scoped lang="css">
.text-container {
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
}

.text-box {
  position: absolute;
  width: 100%;
  height: 100%;
}

.grab {
  cursor: grab;
}

.grabbing {
  cursor: grabbing;
}

.disabled-border {
  pointer-events: none;
  border: 1px dashed #2d2d2d; /* ~gray-800 */
}

.dotted-red-border {
  border: 1px dotted #ef4444; /* ~red-500 */
}

.editable-text {
  outline: none;
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/pdf-lib-contents/TextItem.vue